import React from 'react';
import './TabMenu.css';

export interface TabMenuProps {
  children: React.ReactNode;
  variant?: 'default' | 'queue';
  className?: string;
  noFlexGrow?: boolean;
}

export const TabMenu: React.FC<TabMenuProps> = ({ 
  children, 
  variant = 'default',
  className = '',
  noFlexGrow = false
}) => {
  return (
    <div className={`tab-menu tab-menu-${variant} ${noFlexGrow ? 'tab-menu-no-flex-grow' : ''} ${className}`}>
      {children}
    </div>
  );
};

